import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
	name: 'user',
	initialState: {
        username: undefined,
        jwt: undefined,
        userInfo: {}
    },
	reducers: {
		setUser: (state, action) => {
			state.username = action.payload.username;
			state.jwt = action.payload.jwt;
			if (action.payload.hasOwnProperty("userInfo"))
			{
				state.userInfo = action.payload.userInfo;
			}
		},
		setUserInfo: (state, action) => {
			state.userInfo = action.payload.userInfo;
		},
		signOut: (state, action) => {
			state.username = undefined;
			state.jwt = undefined;
			state.userInfo = {}
		},
	},
});

export const selectUserInfo = (state) => {
	return state.user.userInfo;
}

export const selectUserCredentials = (state) => {

	let credentials = undefined;
	
	if (state.user.jwt)
	{
		credentials = {jwt: state.user.jwt};
	}

	return credentials;
}

export const isUserSignIn = (state) => {
	return state.user.username !== undefined;
}

export const { 
	setUser,
	setUserInfo,
	signOut,
} = userSlice.actions;

export default userSlice.reducer;
